<template>
	<div class="brand">
		<table class="table-main">
			<thead>
				<tr>
					<th class="brand__num">브랜드 항번</th>
					<th class="brand__name">브랜드명</th>
					<th class="brand__order">정렬순서</th>
					<th class="brand__date">등록일시</th>
					<th class="brand__button">수정</th>
					<th class="brand__button">삭제</th>
				</tr>
			</thead>
			<tbody>
				<tr v-if="brandList.length === 0">
					<td class="brand__no-data" colspan="6">
						데이터가 없습니다.
					</td>
				</tr>
				<tr v-for="list in brandList" :key="list.idBrand">
					<td class="brand__num">{{ list.idBrand }}</td>
					<td class="brand__name">{{ list.brandTitle }}</td>
					<td class="brand__order">
						<input
							type="number"
							placeholder="정렬순서"
							v-model="list.sortKey"
						/>
					</td>
					<td class="brand__date">
						{{ list.createDate }}
					</td>
					<td class="brand__button">
						<button
							class="btn orange"
							@click="modifyBrand(list.idBrand)"
						>
							수정
						</button>
					</td>
					<td class="brand__button">
						<button
							class="btn red"
							@click="deleteBrand(list.idBrand)"
						>
							삭제
						</button>
					</td>
				</tr>
			</tbody>
		</table>
		<PaginationBox
			class="paging"
			:totalItem="brandListTotal"
			:offset="offset"
			:limit="limit"
			@to="onSearch($event.offset)"
		/>
	</div>
</template>
<script>
	import PaginationBox from '../PaginationBox.vue';

	export default {
		components: { PaginationBox },
		props: {
			brandList: {
				type: Array,
				default: () => [],
			},
			brandListTotal: {
				type: Number,
				default: 0,
			},
			limit: {
				type: Number,
				default: 10,
			},
			offset: {
				type: Number,
				default: 0,
			},
		},
		computed: {
			brandId() {
				return this.$route.params.idBrand;
			},
		},
		methods: {
			async deleteBrand(id) {
				try {
					if (!confirm('정말 삭제하시겠습니까?')) return;
					const params = {
						idBrand: Number(id),
					};
					await this.$axiosAdmin2.delete(
						`/api/brands/category-mapping/${this.brandId}`,
						{ data: params }
					);
					alert('삭제되었습니다.');
					this.$emit('getList');
				} catch (error) {
					alert(
						'삭제에 실패했습니다. 지속적인 문제 발생시 개발팀에 문의주세요.'
					);
					console.error(error);
				}
			},
			async modifyBrand(id) {
				try {
					const params = {
						idBrand: id,
						sortKey: Number(
							this.brandList.find(item => item.idBrand === id)
								.sortKey
						),
					};

					if (!confirm('정말 수정하시겠습니까?')) return;
					await this.$axiosAdmin2.post(
						`/api/brands/category-mapping/${this.brandId}`,
						params
					);
					alert('수정되었습니다.');
					this.$emit('getList');
				} catch (error) {
					alert(
						'수정에 실패했습니다. 지속적인 문제 발생시 개발팀에 문의주세요.'
					);
					console.error(error);
				}
			},
			onSearch(offset) {
				this.$emit('changeOffset', offset);
				this.$emit('getList');
			},
		},
	};
</script>
<style lang="scss" scoped>
	.brand {
		margin-top: 60px;
		&__num {
			width: 10%;
		}
		&__button {
			width: 10%;
		}
		&__date {
			width: 15%;
		}
		&__order {
			width: 20%;
		}
		&__no-data {
			height: 200px;
			text-align: center;
			color: #c7c7c7;
		}
	}
	.paging {
		margin-top: 30px;
	}
</style>
